<script>
    import axios from "axios";
    import * as yup from "yup";

    import Button from "../../components/Buttons/Button.svelte";
    import Input from "../../components/Inputs/Input.svelte";

    import { validateForm } from "../../utils/Form";
    import { playAnimation } from "../../utils/SVGator";
    import { successToast, errorToast500 } from "../../utils/CommonToasts";

    let values = {};
    let errors = {};
    let formValid = false;
    let isSubmitting = false;

    const schema = yup.object().shape({
        email: yup.string().email("Must be a valid email").required(""),
    });

    const validateFormOnKeyup = async () => {
        formValid = await validateForm(schema, values);
    };

    const submitHandler = async () => {
        isSubmitting = true;
        playAnimation("mailbox-svg", "etal2f7el0gf1");
        await axios
            .post(
                APIBACKEND + "/user/checkemail",
                { email: values.email },
                { withCredentials: true }
            )
            .then(function (res) {
                if (res.data.exists) {
                    setTimeout(function () {
                        successToast(
                            "A login link has been sent to your email!"
                        );
                        isSubmitting = false;
                    }, 800);
                } else {
                    window.location.replace("/account");
                }
            })
            .catch(() => {
                errorToast500();
            });
    };
</script>

<style lang="scss">
    @import "../../styles/_mixins.scss";

    form {
        padding-right: var(--spacer-medium);
        padding-left: var(--spacer-medium);
        width: 100%;

        @include md {
            width: 350px;
            height: 125px;
        }

        :global(.input-container) {
            margin-bottom: var(--spacer-small);
        }

        p {
            font-size: var(--font-small);
            color: var(--color-orange);
        }
    }
</style>

<form on:submit|preventDefault={submitHandler}>
    <Input
        name="email"
        label="What's your email?"
        id="emailField"
        placeholder="your@email.com"
        onKeyup={validateFormOnKeyup}
        onChange={validateFormOnKeyup}
        bind:value={values.email}
        type="email"
        helperText="You agree to our privacy policy when you click continue"
        required />

    <Button
        primary
        position={'right'}
        text="Continue"
        buttonType="submit"
        disabled={!formValid || isSubmitting} />
    {#if errors.email}
        <p>{errors.email}</p>
    {/if}
</form>
